import { useState } from "react";
import Fab from "@mui/material/Fab";
import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Icon from "@mdi/react";
import { mdiMenu } from "@mdi/js";
import { useWindowSize } from "../hooks/windowHooks";
import { useAppStore } from "../store/appStore";
import Menu, { sidebarWidth } from "./Menu";
import Top51VotePage from "./Top51/Top51VotePage";
import Top51TrendPage from "./Top51/Top51TrendPage";
import Top30VotePage from "./Top30/Top30VotePage";
import Top30VoteTrendPage from "./Top30/Top30VoteTrendPage";
import Top30RankTrendPage from "./Top30/Top30RankTrendPage";
import Top21VoteTrendPage from "./Top21/Top21VoteTrendPage";
import Top21VoteComparePage from "./Top21/Top21VoteComparePage";
import Top21RankTrendPage from "./Top21/Top21RankTrendPage";
import Top21VotePage from "./Top21/Top21VotePage";
import Top18VoteTrendPage from "./Top18/Top18VoteTrendPage";
import Top18VoteComparePage from "./Top18/Top18VoteComparePage";
import Top18RankTrendPage from "./Top18/Top18RankTrendPage";
import Top18VotePage from "./Top18/Top18VotePage";
import Top16VoteTrendPage from "./Top16/Top16VoteTrendPage";
import Top16VoteComparePage from "./Top16/Top16VoteComparePage";
import Top16RankTrendPage from "./Top16/Top16RankTrendPage";
import Top16VotePage from "./Top16/Top16VotePage";
import Top14VoteTrendPage from "./Top14/Top14VoteTrendPage";
import Top14VoteComparePage from "./Top14/Top14VoteComparePage";
import Top14RankTrendPage from "./Top14/Top14RankTrendPage";
import Top14VotePage from "./Top14/Top14VotePage";
import Top12VoteTrendPage from "./Top12/Top12VoteTrendPage";
import Top12VoteComparePage from "./Top12/Top12VoteComparePage";
import Top12RankTrendPage from "./Top12/Top12RankTrendPage";
import Top12VotePage from "./Top12/Top12VotePage";
import OverallRankTrendPage from "./Overall/OverallRankTrendPage";

const fabStyle = {
	position: "absolute",
	bottom: 16,
	right: 16,
};

const MainLayout = () => {
	const { width } = useWindowSize();
	const [drawerOpen, setDrawerOpen] = useState(false);
	const page = useAppStore((state) => state.page);

	return (
		<Stack direction="row" spacing={0}>
			<Box width={width >= 1080 ? width - sidebarWidth : width}>
				{page === "overall-rank-trend" ? (
					<OverallRankTrendPage />
				) : page === "top51-votes" ? (
					<Top51VotePage />
				) : page === "top51-trend" ? (
					<Top51TrendPage />
				) : page === "top30-vote-trend" ? (
					<Top30VoteTrendPage />
				) : page === "top30-rank-trend" ? (
					<Top30RankTrendPage />
				) : page === "top30-votes" ? (
					<Top30VotePage />
				) : page === "top21-vote-compare" ? (
					<Top21VoteComparePage />
				) : page === "top21-vote-trend" ? (
					<Top21VoteTrendPage />
				) : page === "top21-rank-trend" ? (
					<Top21RankTrendPage />
				) : page === "top21-votes" ? (
					<Top21VotePage />
				) : page === "top18-vote-compare" ? (
					<Top18VoteComparePage />
				) : page === "top18-vote-trend" ? (
					<Top18VoteTrendPage />
				) : page === "top18-rank-trend" ? (
					<Top18RankTrendPage />
				) : page === "top18-votes" ? (
					<Top18VotePage />
				) : page === "top16-vote-compare" ? (
					<Top16VoteComparePage />
				) : page === "top16-vote-trend" ? (
					<Top16VoteTrendPage />
				) : page === "top16-rank-trend" ? (
					<Top16RankTrendPage />
				) : page === "top16-votes" ? (
					<Top16VotePage />
				) : page === "top14-vote-compare" ? (
					<Top14VoteComparePage />
				) : page === "top14-vote-trend" ? (
					<Top14VoteTrendPage />
				) : page === "top14-rank-trend" ? (
					<Top14RankTrendPage />
				) : page === "top14-votes" ? (
					<Top14VotePage />
				) : page === "top12-vote-compare" ? (
					<Top12VoteComparePage />
				) : page === "top12-vote-trend" ? (
					<Top12VoteTrendPage />
				) : page === "top12-rank-trend" ? (
					<Top12RankTrendPage />
				) : (
					<Top12VotePage />
				)}
			</Box>
			{width >= 1080 ? (
				<Box width={sidebarWidth}>
					<Drawer
						variant="permanent"
						anchor="right"
						sx={{
							display: { xs: "none", sm: "block" },
							"& .MuiDrawer-paper": {
								boxSizing: "border-box",
								width: sidebarWidth,
							},
						}}
					>
						<Menu />
					</Drawer>
				</Box>
			) : (
				<>
					<Fab
						sx={fabStyle}
						color="common.white"
						onClick={() => {
							setDrawerOpen(true);
						}}
					>
						<Icon size={1} path={mdiMenu} />
					</Fab>
					<Drawer
						anchor="right"
						open={drawerOpen}
						onClose={() => {
							setDrawerOpen(false);
						}}
					>
						<Box width={sidebarWidth}>
							<Menu />
						</Box>
					</Drawer>
				</>
			)}
		</Stack>
	);
};

export default MainLayout;
